<template>
  <v-card flat>
    <v-card-text>
      {{ $t('audit_process_title') }}: {{$t('audit_process_info', {current: auditProgress.audititem_answered_count, total: auditProgress.audititem_count} )}} ({{auditProgress.progress}}%)
      <v-progress-linear v-model="auditProgress.progress"></v-progress-linear>
    </v-card-text>
    <v-divider></v-divider>
  </v-card>
</template>


<i18n>
{
  "de" : {
    "audit_process_title" : "Fortschritt des Audits",
    "audit_process_info" : "{current} von {total} Fragen bearbeitet"
  },
  "en" : {
    "audit_process_title" : "Progress in audit",
    "audit_process_info" : "{current} of {total} questions finished"
  }
}
</i18n>
<script>
export default {
  props: {
    auditProgress: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
